import {apiUrl} from "../utils/constants";
import {POST} from "./api.service.wrapper";


export const PostQuotation = async (args) => {
    const response = await POST(apiUrl.quotations, args);
    return response;
}